import { __assign } from "tslib";
import React, { Suspense } from 'react';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapStarRating = React.lazy(function () {
    return import('../../bootstrap-components/components/BTStarRating');
});
var bootStrapStarRating = function (props) {
    return (React.createElement(BootStrapStarRating, __assign({}, props)));
};
export var StarRating = function (props) {
    var componentToDisplay = bootStrapStarRating(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
StarRating.defaultProps = {
    isGridComponent: false
};
export default StarRating;
//# sourceMappingURL=StarRating.js.map